import React, { useState } from 'react';
import { Form, Modal, Tabs } from 'antd';
import { routerRedux } from 'dva/router';
import { connect } from 'dva';
import { NEW_TEST_CASE } from '../../../../constants';
import { NEWTESTCASE_MODAL } from '../../../../testUtils';
import {
  DISNEY_PLUS_PUBLISHER,
  ESPN_PUBLISHER,
  HULU_PUBLISHER,
  HULU_PLUS_PUBLISHER,
  OFF_PLATFORM_PUBLISHER,
  NEWS_ENT_PUBLISHER,
  ROKU_FAST_PUBLISHER,
  FUBO_PUBLISHER,
} from '../../constants';
import PublisherSelector from './components/PublisherSelector';
import SwidForm from './components/SwidForm';
import AccountProfileForm from './components/AccountProfileForm';
import HuluAccountProfileForm from './components/HuluAccountProfileForm';
import HuluPlusAccountProfileForm from './components/HuluPlusAccountProfileForm';
import NewsEntForm from './components/NewsEntForm';
import IpForm from './components/IpForm';
import RokuFastForm from './components/RokuFastForm';
import FuboForm from './components/FuboForm';

const MODAL_TITLE = 'Link New Account';

const AddAccount = ({ dispatch, open, setModalOpen, permissions }) => {
  const [accountProfileForm] = Form.useForm();
  const [userIdForm] = Form.useForm();
  const [swidForm] = Form.useForm();
  const [selectedPublisher, setSelectedPublisher] = useState('');

  const onCancel = () => {
    dispatch(routerRedux.push('/' + NEW_TEST_CASE));
    setModalOpen(false);
    setSelectedPublisher('');
    accountProfileForm.resetFields();
    userIdForm.resetFields();
    swidForm.resetFields();
  };

  const onSubmitAccountId = ({ accountId, profileId, nickname }) => {
    const publisher = selectedPublisher;
    if (dispatch({ type: 'newTestCase/addAccountId', payload: accountId, profileId, nickname, publisher })) {
      onCancel();
    }
  };

  const onSubmitSwid = ({ swid, nickname }) => {
    if (dispatch({ type: 'newTestCase/addEspnSwidAccount', payload: swid, nickname })) {
      onCancel();
    }
  };

  const onSubmitIp = ({ ip, nickname, channel, 'distro-partner': distroPartner }) => {
    if (dispatch({ type: 'newTestCase/addIpAccount', payload: ip, nickname, channel, distroPartner })) {
      onCancel();
    }
  };

  const onSubmitNewsEnt = ({ swid, nickname, app }) => {
    if (dispatch({ type: 'newTestCase/addNewsEntAccount', payload: { swid, nickname, app } })) {
      onCancel();
    }
  };

  const onSubmitRokuFast = ({ deviceIfa, nickname }) => {
    if (dispatch({ type: 'newTestCase/addRokuFastAccount', payload: { deviceIfa, nickname } })) {
      onCancel();
    }
  };

  const onSubmitFubo = ({ fuboUserId, nickname }) => {
    if (dispatch({ type: 'newTestCase/addFuboAccount', payload: { fuboUserId, nickname } })) {
      onCancel();
    }
  };

  const backBtnClick = () => {
    setSelectedPublisher('');
  };

  const renderModalContent = (publisher) => {
    switch (publisher) {
      case DISNEY_PLUS_PUBLISHER:
        return <AccountProfileForm form={accountProfileForm} onSubmit={onSubmitAccountId} onBack={backBtnClick} />;
      case HULU_PUBLISHER:
        return <HuluAccountProfileForm form={accountProfileForm} onSubmit={onSubmitAccountId} onBack={backBtnClick} />;
      case HULU_PLUS_PUBLISHER:
        return (
          <HuluPlusAccountProfileForm form={accountProfileForm} onSubmit={onSubmitAccountId} onBack={backBtnClick} />
        );
      case ESPN_PUBLISHER:
        return <SwidForm form={swidForm} onSubmit={onSubmitSwid} onBack={backBtnClick} />;
      case OFF_PLATFORM_PUBLISHER:
        return (
          <Tabs
            defaultActiveKey="1"
            size={'medium'}
            style={{ marginBottom: 32 }}
            items={[
              {
                label: 'IP Address',
                key: 0,
                children: <IpForm onSubmit={onSubmitIp} onBack={backBtnClick} />,
              },
            ]}
          />
        );
      case NEWS_ENT_PUBLISHER:
        return <NewsEntForm onSubmit={onSubmitNewsEnt} onBack={backBtnClick} />;
      case ROKU_FAST_PUBLISHER:
        return <RokuFastForm onSubmit={onSubmitRokuFast} onBack={backBtnClick} />;
      case FUBO_PUBLISHER:
        return <FuboForm onSubmit={onSubmitFubo} onBack={backBtnClick} />;
      default:
        return <PublisherSelector onPublisherSelect={setSelectedPublisher} permissions={permissions} />;
    }
  };

  return (
    <Modal title={MODAL_TITLE} open={open} onCancel={onCancel} footer={null} width={600}>
      <div data-testid={NEWTESTCASE_MODAL}>{renderModalContent(selectedPublisher)}</div>
    </Modal>
  );
};

function mapStateToProps(state) {
  return {
    permissions: state.app.currentUser.permissions,
  };
}

export { AddAccount };
export default connect(mapStateToProps)(AddAccount);
